import styles from './slider.module.scss';
import ImageWrapper from '@/shared-components/ImageWrapper/ImageWrapper';

interface ImageWithTextSlideProps {
    image: Partial<ImageProps>;
    text: React.ReactNode;
}

export default function ImageWithTextSlide({ image, text }: ImageWithTextSlideProps): React.JSX.Element {
    return (
        <>
            {image.source && (
                <ImageWrapper
                    optimizedWidth={274}
                    optimizedHeight={154}
                    src={image.source}
                    alt={image.altText ?? ''}
                    className={styles.imageStyles}
                />
            )}
            {text && <p className={styles.slideText}>{text}</p>}
        </>
    );
}
